import Vue from 'vue'
import Store from '@/store/store'
import Router from 'vue-router'

import ArticlesPage from '@/components/articles-page'
import Articles from '@/components/articles'
import Compounds from '@/components/compounds'
import Cart from '@/components/cart'
import History from '@/components/history'
import HomePage from '@/components/home-page'
import Login from '@/components/login'
import Pages from '@/components/pages.vue'
import PasswordReset from '@/components/user-account/password-reset.vue'
import UserAccountCreate from '@/components/user-account-create'
import UserDetails from '@/components/user-details'

Vue.use(Router)
let store = Store

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/oferta',
      name: 'offer',
      component: Articles,
      meta: {
        showPublic: true,
        showProtected: true,
        icon: 'el-icon-thumb',
        category: 'oferta',
        label: 'Oferta'
      }
    },
    {
      path: '/',
      name: 'pages',
      component: Pages,
      meta: {
        showPublic: true,
        showProtected: true,
        icon: 'el-icon-house',
        label: 'Strony'
      },
      children: [
        {
          path: '/',
          name: 'homepage',
          component: HomePage,
          meta: {
            showPublic: true,
            showProtected: true,
            icon: 'el-icon-house',
            label: 'Strona główna'
          }
        },
        {
          path: '/oferta',
          name: 'offer',
          component: Articles,
          meta: {
            showPublic: true,
            showProtected: true,
            icon: 'el-icon-thumb',
            category: 'oferta',
            label: 'Oferta'
          }
        },
        {
          path: '/aktualnosci',
          name: 'news',
          component: Articles,
          meta: {
            showPublic: true,
            showProtected: true,
            icon: 'el-icon-news',
            category: 'aktualnosci',
            label: 'Aktualności'
          }
        },
        {
          path: '/informacje',
          name: 'informations',
          component: Articles,
          meta: {
            showPublic: true,
            showProtected: true,
            icon: 'el-icon-notebook-1',
            category: 'informacje',
            label: 'Informacje'
          }
        },
        {
          path: '/a/:articleCategory/:articleSlug',
          name: 'articles-page',
          component: ArticlesPage,
          meta: {
            showPublic: false,
            showProtected: false
          }
        }
      ]
    },
    {
      path: '/produkty/:selectedCompound?',
      name: 'compounds',
      component: Compounds,
      props: true,
      meta: {
        showPublic: true,
        showProtected: true,
        icon: 'el-icon-notebook-2',
        label: 'Znajdź produkt'
      }
    },
    {
      path: '/koszyk',
      name: 'cart-items',
      component: Cart,
      meta: {
        showPublic: false,
        showProtected: false,
        icon: 'el-icon-s-goods',
        label: 'Koszyk'
      }
    },
    {
      path: '/historia-zmowien',
      name: 'carts',
      component: History,
      meta: {
        showPublic: false,
        showProtected: true,
        icon: 'el-icon-files',
        label: 'Historia zamówień'
      }
    },
    {
      path: '/konto/dodaj',
      name: 'user-account-create',
      component: UserAccountCreate,
      meta: {
        showPublic: true,
        showProtected: false,
        icon: 'el-icon-user',
        label: 'Utwórz konto'
      }
    },
    {
      path: '/zaloguj',
      name: 'login',
      component: Login,
      meta: {
        showPublic: false,
        showProtected: false,
        icon: 'el-icon-unlock',
        label: 'Zaloguj'
      }
    },
    {
      path: '/konto',
      name: 'user-account',
      component: UserDetails,
      meta: {
        showPublic: false,
        showProtected: false,
        icon: 'el-icon-edit-outline',
        label: 'Konto'
      }
    },
    {
      path: '/konto/zresetuj-haslo/:code',
      name: 'user-account-password-reset',
      component: PasswordReset,
      meta: {
        label: 'Zresetuj hasło'
      }
    },
    {
      path: '/wyloguj',
      name: 'logout',
      meta: {
        click: 'aLogout',
        showPublic: false,
        showProtected: false,
        icon: 'el-icon-switch-button',
        label: 'Wyloguj'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // set search
  if (to.query.q) {
    store.commit('mUpdateQ', to.query.q)
  } else {
    if (store.state.q) {
      to.query.q = store.state.q
    }
  }

  if (to.query.msg) {
    store.dispatch('aMessageDisplay', to.query.msg)
  }
  store.commit('mSetPage', 1)
  if (to.meta.isProtected) {
    if (sessionStorage.getItem('tkn') == null) {
      next({
        name: 'login',
        params: { nextUrl: to.fullPath }
      })
    }
  }
  document.title = store.getters.getPageTitle(to.meta.label)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js